/* eslint-disable unicorn/prefer-export-from */
import type {
  CanonicalTweetArray as ContractCanonicalTweetArray,
  ContextAnnotation as ContractContextAnnotation,
  ReferencedTweet as ContractReferencedTweet,
  CanonicalTweet as ContractTweet,
  TweetAlgorithmicMetadata as ContractTweetAlgorithmicMetadata,
  TweetAttachments as ContractTweetAttachments,
  TweetAuthor as ContractTweetAuthor,
  TweetAuthorAffiliation as ContractTweetAuthorAffiliation,
  TweetAuthorPublicMetrics as ContractTweetAuthorPublicMetrics,
  TweetEmbeddableStatus as ContractTweetEmbeddableStatus,
  TweetEntities as ContractTweetEntities,
  TweetLinkMetadata as ContractTweetLinkMetadata,
  TweetMediaArray as ContractTweetMediaArray,
  TweetMediaDedupeDecision as ContractTweetMediaDedupeDecision,
  TweetMediaItem as ContractTweetMediaItem,
  TweetMediaMetadataEntry as ContractTweetMediaMetadataEntry,
  TweetMediaVariant as ContractTweetMediaVariant,
  TweetMetadataRecord as ContractTweetMetadataRecord,
  TweetMetrics as ContractTweetMetrics,
  TweetReplySettings as ContractTweetReplySettings,
  TweetSuggestionType as ContractTweetSuggestionType,
} from '@sweetistics/contracts/tweets-canonical';
import {
  CanonicalTweetArraySchema as CanonicalTweetArraySchemaInternal,
  CanonicalTweetMetadataRecordSchema as CanonicalTweetMetadataRecordSchemaInternal,
  ContextAnnotationSchema as ContextAnnotationSchemaInternal,
  ReferencedTweetSchema as ReferencedTweetSchemaInternal,
  TweetAlgorithmicMetadataSchema as TweetAlgorithmicMetadataSchemaInternal,
  TweetAttachmentsSchema as TweetAttachmentsSchemaInternal,
  TweetAuthorAffiliationSchema as TweetAuthorAffiliationSchemaInternal,
  TweetAuthorPublicMetricsSchema as TweetAuthorPublicMetricsSchemaInternal,
  TweetAuthorSchema as TweetAuthorSchemaInternal,
  TweetEmbeddableStatusSchema as TweetEmbeddableStatusSchemaInternal,
  TweetEntitiesSchema as TweetEntitiesSchemaInternal,
  TweetLinkMetadataSchema as TweetLinkMetadataSchemaInternal,
  TweetMediaDedupeDecisionSchema as TweetMediaDedupeDecisionSchemaInternal,
  TweetMediaItemSchema as TweetMediaItemSchemaInternal,
  TweetMediaMetadataEntrySchema as TweetMediaMetadataEntrySchemaInternal,
  TweetMediaVariantSchema as TweetMediaVariantSchemaInternal,
  TweetMetricsSchema as TweetMetricsSchemaInternal,
  TweetReplySettingsSchema as TweetReplySettingsSchemaInternal,
  CanonicalTweetSchema as TweetSchemaInternal,
  TweetSuggestionTypeSchema as TweetSuggestionTypeSchemaInternal,
} from '@sweetistics/contracts/tweets-canonical';

type Tweet = ContractTweet;
type CanonicalTweetArray = ContractCanonicalTweetArray;
type ContextAnnotation = ContractContextAnnotation;
type ReferencedTweet = ContractReferencedTweet;
type TweetAlgorithmicMetadata = ContractTweetAlgorithmicMetadata;
type TweetAttachments = ContractTweetAttachments;
type TweetAuthor = ContractTweetAuthor;
type TweetAuthorAffiliation = ContractTweetAuthorAffiliation;
type TweetAuthorPublicMetrics = ContractTweetAuthorPublicMetrics;
type TweetEmbeddableStatus = ContractTweetEmbeddableStatus;
type TweetEntities = ContractTweetEntities;
type TweetMediaArray = ContractTweetMediaArray;
type TweetMediaDedupeDecision = ContractTweetMediaDedupeDecision;
type TweetMediaItem = ContractTweetMediaItem;
type TweetMediaMetadataEntry = ContractTweetMediaMetadataEntry;
type TweetMediaVariant = ContractTweetMediaVariant;
type TweetMetadataRecord = ContractTweetMetadataRecord;
type TweetMetrics = ContractTweetMetrics;
type TweetSuggestionType = ContractTweetSuggestionType;
type LinkMetadata = ContractTweetLinkMetadata;
type ReplySettings = ContractTweetReplySettings;

type ContractTweetAuthorType = ContractTweetAuthor;
type ContractTweetSuggestionTypeType = ContractTweetSuggestionType;

type AlgorithmicSuggestionCanonical = ContractTweetSuggestionTypeType['canonical'];

type TweetWithAuthor = ContractTweet & {
  author: ContractTweetAuthorType;
};

type TweetPreview = Pick<
  ContractTweet,
  'id' | 'text' | 'createdAt' | 'likeCount' | 'retweetCount' | 'replyCount' | 'quoteCount'
>;

export type {
  Tweet,
  CanonicalTweetArray,
  ContextAnnotation,
  ReferencedTweet,
  TweetAlgorithmicMetadata,
  TweetAttachments,
  TweetAuthor,
  TweetAuthorAffiliation,
  TweetAuthorPublicMetrics,
  TweetEmbeddableStatus,
  TweetEntities,
  TweetMediaArray,
  TweetMediaDedupeDecision,
  TweetMediaItem,
  TweetMediaMetadataEntry,
  TweetMediaVariant,
  TweetMetadataRecord,
  TweetMetrics,
  TweetSuggestionType,
  LinkMetadata,
  ReplySettings,
  AlgorithmicSuggestionCanonical,
  TweetWithAuthor,
  TweetPreview,
};

export const CanonicalTweetArraySchema = CanonicalTweetArraySchemaInternal;
export const CanonicalTweetMetadataRecordSchema = CanonicalTweetMetadataRecordSchemaInternal;
export const ContextAnnotationSchema = ContextAnnotationSchemaInternal;
export const ReferencedTweetSchema = ReferencedTweetSchemaInternal;
export const TweetAlgorithmicMetadataSchema = TweetAlgorithmicMetadataSchemaInternal;
export const TweetAttachmentsSchema = TweetAttachmentsSchemaInternal;
export const TweetAuthorAffiliationSchema = TweetAuthorAffiliationSchemaInternal;
export const TweetAuthorPublicMetricsSchema = TweetAuthorPublicMetricsSchemaInternal;
export const TweetAuthorSchema = TweetAuthorSchemaInternal;
export const TweetEmbeddableStatusSchema = TweetEmbeddableStatusSchemaInternal;
export const TweetEntitiesSchema = TweetEntitiesSchemaInternal;
export const TweetLinkMetadataSchema = TweetLinkMetadataSchemaInternal;
export const TweetMediaDedupeDecisionSchema = TweetMediaDedupeDecisionSchemaInternal;
export const TweetMediaItemSchema = TweetMediaItemSchemaInternal;
export const TweetMediaMetadataEntrySchema = TweetMediaMetadataEntrySchemaInternal;
export const TweetMediaVariantSchema = TweetMediaVariantSchemaInternal;
export const TweetMetricsSchema = TweetMetricsSchemaInternal;
export const TweetReplySettingsSchema = TweetReplySettingsSchemaInternal;
export const TweetSuggestionTypeSchema = TweetSuggestionTypeSchemaInternal;
export const TweetSchema = TweetSchemaInternal;
